import { render, staticRenderFns } from "./dataAuth.vue?vue&type=template&id=a56858f2&scoped=true"
import script from "./dataAuth.vue?vue&type=script&lang=js"
export * from "./dataAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56858f2",
  null
  
)

export default component.exports